module.exports = __webpack_public_path__ + "img/ch14_01_绿皮火车看云.61f8d53e.jpg";